<template>
    <hyper-modal
        modal-class="secondary"
        :value="value"
        @input="$emit('input', $event)"
        class="modal-base modal-admin-info size-md"
        v-cloak
    >
        <h4 slot="header" class="modal-title">My Account</h4>
        <div slot="body">
            <div
                class="alert"
                v-if="message"
                :class="{'alert-danger': message_error, 'alert-success': !message_error}"
                v-cloak
            >{{ message }}</div>
            <form class="form-horizontal">
                <div class="form-group row mb-3">
                    <label class="col-4 col-form-label">Name</label>
                    <div class="col-8">
                        <input type="text" v-model="form.name" class="form-control" />
                        <form-error-label :target="errors['name']"></form-error-label>
                    </div>
                </div>
                <div class="form-group row mb-3">
                    <label class="col-4 col-form-label">E-mail Address</label>
                    <div class="col-8">
                        <input type="text" v-model="form.email" class="form-control" />
                        <form-error-label :target="errors['email']"></form-error-label>
                    </div>
                </div>
                <div class="alert alert-light reset-password">
                    <h5>Change Password</h5>
                    <div class="form-group row mb-3">
                        <label class="col-5 col-form-label">Current Password</label>
                        <div class="col-7">
                            <input
                                type="password"
                                v-model="form.current_password"
                                class="form-control"
                                :class="[hasError('current_password')]"
                            />
                            <form-error-label :target="errors['current_password']"></form-error-label>
                        </div>
                    </div>
                    <div class="form-group row mb-3">
                        <label class="col-5 col-form-label">New Password</label>
                        <div class="col-7">
                            <input
                                type="password"
                                v-model="form.password"
                                class="form-control"
                                :class="[hasError('password')]"
                            />
                            <form-error-label :target="errors['password']"></form-error-label>
                        </div>
                    </div>
                    <div class="form-group row mb-2">
                        <label class="col-5 col-form-label">Confirm New Password</label>
                        <div class="col-7">
                            <input
                                type="password"
                                v-model="form.password_confirmation"
                                class="form-control"
                                :class="[hasError('password_confirmation')]"
                            />
                            <form-error-label :target="errors['password_confirmation']"></form-error-label>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <template slot="footer">
            <div class="loading-container">
                <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="popup_loading"
                ></span>
            </div>
            <button class="btn btn-light" @click="closeMyInfo()" type="button">Close</button>
            <button
                @click="saveUserInfo()"
                class="btn btn-primary"
                type="button"
                :disabled="popup_loading"
            >Save</button>
        </template>
    </hyper-modal>
</template>

<script>
// import axios from "axios";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import user from "@/client/api/user";

import HyperModal from "@/ui/HyperModal";
import FormErrorLabel from "@/ui/FormErrorLabel.js";

export default {
    props: ["value"],
    components: {
        HyperModal,
        FormErrorLabel
    },
    data() {
        return {
            // popup_my_info: false,
            popup_loading: false,
            message_error: false,
            message: null,
            errors: [],
            show_errors: false,
            form: {
                id: null,
                username: null,
                name: null,
                email: null
                // current_password: null,
                // password: null,
                // password_confirm: null
            }
        };
    },
    watch: {
        value: {
            handler: function() {
                this.loadMyInfo();
            },
            immediate: true
        }
    },
    methods: {
        // User info modal
        // showMyInfo() {
        //     this.loadMyInfo();
        //     this.popup_my_info = true;
        // },
        closeMyInfo() {
            // this.popup_my_info = false;
            this.$emit("input", false);
        },
        async loadMyInfo() {
            this.message = null;
            this.message_error = false;
            this.errors = [];
            this.popup_loading = true;

            try {
                let res = await user.getMyInfo();
                console.log(res);
                if (res.data && res.data.data) {
                    this.form = res.data.data;
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.popup_loading = false;
            }
        },
        async saveUserInfo() {
            if (this.popup_loading) return;

            this.message = null;
            this.message_error = false;
            this.errors = [];
            this.show_errors = false;
            this.popup_loading = true;

            try {
                let res = await user.postMyInfo(this.form);
                if (res.data && res.data.status && res.data.status == "ok") {
                    this.message_error = false;
                    this.message = "Saved successfully.";

                    if (res.data.data) {
                        this.form = res.data.data;
                        // this.my_info = res.data.data;
                        this.getMyInfo();
                    }
                }
            } catch (err) {
                console.log(err);
                if (err.response) {
                    var res = err.response;
                    if (res.status == 422) {
                        // console.log(res.message);
                        this.errors = res.data.errors;
                        this.show_errors = true;
                        this.message =
                            "Validation error. Please check your input.";
                    } else if (res.status == 500) {
                        this.message =
                            "System error occured. Please try again.";
                    } else {
                        this.message = "Unknown error occured.";
                    }
                    this.message_error = true;
                    // this.show_popup_message = true;
                }
            } finally {
                this.form.current_password = null;
                this.form.password = null;
                this.form.password_confirmation = null;
                this.popup_loading = false;
            }
        },
        hasError(input_id) {
            if (this.show_errors) {
                return this.errors[input_id] ? "is-invalid" : null;
            }
        },
        ...mapActions("user", ["getMyInfo"])
    }
};
</script>

<style>
</style>